module.exports = __webpack_public_path__ + "img/lost.6781455.svg";